import type React from "react";
import { createContext, useContext } from "react";

type MenuType = React.ElementType | null;

const MenuContext = createContext<MenuType>(null);

interface MenuProviderProps {
  component: React.ElementType;
  children: React.ReactNode;
}

export const MenuProvider = ({ component, children }: MenuProviderProps) => {
  return (
    <MenuContext.Provider value={component}>{children}</MenuContext.Provider>
  );
};

export const useMenu = () => {
  const context = useContext(MenuContext);

  if (context === null) {
    throw new Error("useMenu must be used within a MenuProvider");
  }

  return context;
};
